
import { Link } from 'react-router-dom';
import { useSEO, generateBreadcrumbSchema } from '../../utils/seo';
import AdHero from './components/AdHero';
import PricingPlans from './components/PricingPlans';
import SponsoredContentPricing from './components/SponsoredContentPricing';
import SponsoredContentForm from './components/SponsoredContentForm';
import ComparisonTable from './components/ComparisonTable';
import AdDirectory from './components/AdDirectory';
import InquiryForm from './components/InquiryForm';

export default function AdvertisePage() {
  useSEO({
    title: 'Advertise in Roseville CA | Premium Business Listings & Sponsored Content | Roseville.org',
    description: 'Reach 50,000+ Roseville residents with premium business listings, sponsored content, and native advertising on Roseville.org. Plans start at $49/month. Boost your local visibility today.',
    keywords: 'advertise Roseville CA, Roseville business advertising, local marketing Roseville, sponsored content Roseville, business listings Roseville.org',
    canonical: '/advertise',
    ogImage: 'https://public.readdy.ai/ai/img_res/2d1e4f80f5d6eedb2b7be5b71ef7643b.jpg',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebPage',
          name: 'Advertise Your Business — Roseville.org',
          description: 'Premium advertising and business listing options on Roseville.org to reach local Roseville, CA customers.',
          url: `${import.meta.env.VITE_SITE_URL || 'https://roseville.org'}/advertise`,
          inLanguage: 'en-US',
        },
        generateBreadcrumbSchema([
          { name: 'Home', url: '/' },
          { name: 'Advertise', url: '/advertise' },
        ]),
        {
          '@type': 'Service',
          name: 'Roseville.org Advertising Services',
          description: 'Local advertising solutions for businesses targeting Roseville, California residents.',
          provider: {
            '@type': 'Organization',
            name: 'Roseville.org',
            url: import.meta.env.VITE_SITE_URL || 'https://roseville.org',
          },
          areaServed: { '@type': 'City', name: 'Roseville', addressRegion: 'CA' },
          serviceType: 'Digital Advertising',
        },
      ],
    },
  });

  return (
    <div className="min-h-screen bg-gray-50">
      <AdHero />
      
      {/* Display Advertising CTA Banner */}
      <section className="py-12 bg-gradient-to-r from-teal-600 to-teal-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-white">
              <h2 className="text-3xl font-bold mb-2">Display Advertising Available</h2>
              <p className="text-lg text-white/90">
                Reach 50,000+ monthly visitors with banner ads, sidebar placements, and in-content advertising
              </p>
            </div>
            <Link
              to="/advertise-display"
              className="bg-white text-teal-600 px-8 py-4 rounded-lg font-semibold hover:bg-teal-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap flex items-center gap-2"
            >
              <i className="ri-advertisement-line text-xl"></i>
              View Display Ad Options
            </Link>
          </div>
        </div>
      </section>
      
      <PricingPlans />
      <SponsoredContentPricing />
      <SponsoredContentForm />
      <ComparisonTable />
      <AdDirectory />
      <InquiryForm />
    </div>
  );
}
